import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GiftSectionComponent } from './gift-section/gift-section.component';
import { IonicModule } from '@ionic/angular';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { GiftCardComponent } from 'src/app/pages/buy-gift-cards/buy-gift-cards-components/gift-card/gift-card.component';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { ComponentsCompraModule } from '../../vista-compra/components-compra/components-compra.module';
import { TranslateModule } from '@ngx-translate/core';

const declarations = [GiftSectionComponent, GiftCardComponent];

@NgModule({
  declarations,
  imports: [
    CommonModule,
    IonicModule,
    GeneralesComponentsModule,
    PipeModule,
    ComponentsCompraModule,
    TranslateModule,
  ],
  exports: declarations,
})
export class BuyGiftCardsComponentsModule {}
